import request from "@/utils/request.js";
class Api {
  // 修改个人信息
  editInfo(data) {
    return request({
      method: "post",
      url: "/kf_user/edit/mine",
      data,
    });
  }
  //   客服修改自己的密码
  changePassword(data) {
    return request({
      method: "post",
      url: "/kf_user/change_password",
      data,
    });
  }
  // 客服修改自己的状态
  changeStatus(data) {
    return request({
      method: "post",
      url: "/kf_user/change_status",
      data,
    });
  }
}
export default new Api();
